declare namespace $ {

	export class $mol_icon_database extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=database.view.tree.d.ts.map